var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHireToRetire(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "eks-icon-hire-to-retire"
  }, "Hire-to-Retire") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "eks-icon-hire-to-retire"
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 6,
    r: 2.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 12c0-2 1.8-3.5 4-3.5s4 1.5 4 3.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20c0-4.4 3.6-8 8-8s8 3.6 8 8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHireToRetire);
export default __webpack_public_path__ + "static/media/hire-to-retire.a7b7589342ed41fcb4b289fe80ea9af9.svg";
export { ForwardRef as ReactComponent };